<style scoped lang="less">
  .title{
    padding: 0 10px;
  }
  .allot-total{
    padding: 10px 0;
    text-align: center;
  }
  .asset-table {
    /deep/.active:hover {
      cursor: pointer;
      color: #2d8cf0;
    }
  }
  .asset-price-total {
    display: flex;
    justify-content: flex-end;
  }
</style>
<template>
  <div>
    <Row v-if="is_advance_or_recharge">
      <i-col span="12">
        <h4 class="title">
          按团队分配:
        </h4>
        <Table
          size="small"
          :columns="expense_team_columns"
          :data="expense_teams"
        />
      </i-col>
      <i-col span="12">
        <h4 class="title">
          按spu分配:
        </h4>
        <Table
          size="small"
          :columns="expense_spu_columns"
          :data="expense_spus"
        />
      </i-col>
    </Row>
    <Row
      v-else
      :gutter="4"
    >
      <i-col span="10">
        <h4 class="title">
          按团队分配:
        </h4>
        <Table
          size="small"
          :columns="expense_team_columns"
          :data="expense_teams"
        />
      </i-col>
      <i-col span="10">
        <h4 class="title">
          按spu分配:
        </h4>
        <Table
          size="small"
          :columns="expense_spu_columns"
          :data="expense_spus"
        />
      </i-col>
      <i-col span="14">
        <h4 class="title">
          关联发票:
        </h4>
        <Table
          size="small"
          :columns="expense_invoice_columns"
          :data="invoice_data"
        />
      </i-col>
    </Row>
    <Row
      v-if="assets && assets.length > 1"
      style="margin-top: 10px"
    >
      <i-col span="24">
        <h4 class="title">
          关联固定资产:
        </h4>
        <Table
          class="asset-table"
          size="small"
          :columns="expense_asset_columns"
          :data="assets"
        />
      </i-col>
    </Row>
    
    <AssetDetail ref="asset_detail" />
  </div>
</template>
<script>
  import InvoiceUtil from '../../invoice/libs/util';
  import InvoicePicture from '../../invoice/components/invoice_picture';
  import AssetDetail from '../../exec/asset_detail'
  import { audit_status_hash } from '@/views/invoice/fields.js'
  import {mapGetters} from "vuex";
  import { getsafe } from '../../../libs/util';
  export default {
    components: { InvoicePicture, AssetDetail },
    props: {
      expense: {
        type: Object
      },
      is_advance_or_recharge: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        expense_spu_columns: [
          {
            title: 'SPU',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              console.log(row, 123123123)
              const name = row.name;
              return h('span', name || '-');
            }
          },
          {
            title: '分配金额',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('div', {
                'class': {
                  'text-right': true
                },
                style: {
                  'white-space': 'nowrap'
                }
              }, this.$util.formatPrice(row.amount));
            }
          },
          {
            title: '备注',
            align: 'center',
            key: 'desc',
            render: (h, params) => {
              const row = params.row;
              if (row.desc) {
                return h('div', row.desc);
              } else {
                return h('span', '-');
              }
            }
          }
        ],
        expense_team_columns: [
          {
            title: '团队',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const team = this.teams_hash[row.team_id];
              return h('span', team ? team.name : '-');
            }
          },
          {
            title: '分配金额',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('div', {
                'class': {
                  'text-right': true
                },
                style: {
                  'white-space': 'nowrap'
                }
              }, this.$util.formatPrice(row.price));
            }
          },
          {
            title: '备注',
            align: 'center',
            key: 'desc',
            render: (h, params) => {
              const row = params.row;
              if (row.desc) {
                return h('div', row.desc);
              } else {
                return h('span', '-');
              }
            }
          }
        ],
        expense_invoice_columns: [
          {
            title: '类型',
            align: 'center',
            width: 40,
            render: (h, params) => {
              const row = params.row;
              if (row.invoice_type === '合计') {
                return h('span', '合计');
              }
              const invoice_type = InvoiceUtil.getInvoiceType(row.invoice_type);
              return h('span', {
                'class': {
                  'color-error': row.invoice_type === -1
                }
              }, invoice_type)
            }
          },
          {
            title: '发票提供方',
            align: 'center',
            width: 100,
            render: (h, {row}) => {
              if (row.provider_type === 0) {
                return h('span', '业务申请方');
              }
              if (row.provider_type === 1) {
                return h('span', '财务');
              }
              return h('span', '-');
            }
          },
          {
            title: '发票',
            align: 'center',
            width: 100,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              if (row.code) {
                ret.push(h('div', row.code));
              }
              if (row.uid) {
                ret.push(h('div', row.uid));
              }
              return h('div', ret.length ? ret : '-');
            }
          },
          {
            title: '金额',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('div', {
                'class': {
                  'text-right': true
                },
                style: {
                  'white-space': 'nowrap'
                }
              }, `${this.$util.formatPrice(row.total_price)}`);
            }
          },
          {
            title: '分配金额',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('div', {
                'class': {
                  'text-right': true
                },
                style: {
                  'white-space': 'nowrap'
                }
              }, `${this.$util.formatPrice(row.allot_price)}`);
            }
          },
          {
            title: '分配税额',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              if (row.invoice_type !== 1 && row.invoice_type !== '合计') {
                return h('span', '-');
              }
              return h('div', {
                'class': {
                  'text-right': true
                },
                style: {
                  'white-space': 'nowrap'
                }
              }, `${this.$util.formatPrice(row.allot_tax)}`);
            }
          },
          {
            title: '文件',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              if (row.invoice_file_id) {
                return h(InvoicePicture, {
                  props: {
                    invoice_id: row.id
                  }
                });
              } else {
                return h('div', '-');
              }
            }
          },
          {
            title: '审核状态',
            align: 'center',
            // audit_status_hash
            render: (h, {row}) => {
              const audited = row.audited
              // if (row._index === 0) {
              //   return h('span', '-')
              // }
              if (row.invoice_type && row.invoice_type === "合计") {
                return h('span', '-')
              }
              const status_title = getsafe(audit_status_hash, `${audited}.title`, '-')
              return h('span', [status_title])
            }
          },
          {
            title: '关联时间',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('div', row.updated_at ? this.$util.formatDate(row.updated_at) : '-');
            }
          }
        ],
        expense_asset_columns: [{
          title: '资产编号',
          align: 'center',
          render: (h, params) => {
            const row = params.row
            if (!row.is_total) {
              return h('div', {
                props: {},
                class: {
                  active: true
                },
                on: {
                  click: () => {
                    this.$refs.asset_detail.show(row.id)
                  }
                }
              }, row.uid)
            }
          }
        }, {
          title: '设备类型',
          align: 'center',
          render: (h, params) => {
            if (!params.row.is_total) {
              return h('div', params.row.asset_device_type ? params.row.asset_device_type.name : '无')
            }
          }
        }, {
          title: '型号',
          align: 'center',
          key: 'asset_model'
        }, {
          title: '项目组',
          align: 'center',
          render: (h, params) => {
            if (!params.row.is_total) {
              return h('div', this.teams_hash[params.row.team_id].name)
            }
          }
        }, {
          title: '使用人',
          align: 'center',
          render: (h, params) => {
            if (!params.row.is_total) {
              return h('div', params.row.customer && params.row.customer.account)
            }
          }
        }, {
          title: '用途',
          align: 'center',
          key: 'purpose'
        }, {
          title: '资产类型',
          align: 'center',
          render: (h, params) => {
            if (!params.row.is_total) {
              return h('div', params.row.asset_type && params.row.asset_type.name)
            }
          }
        }, {
          title: '供应商',
          width: 100,
          align: 'center',
          render: (h, params) => {
            if (!params.row.is_total) {
              return h('div', params.row.payee_company.name)
            } else {
              return h('div', '总计')
            }
          }
        }, {
          title: '购入价格',
          align: 'center',
          render: (h, params) => {
            if (!params.row.is_total) {
              return h('div', params.row.price)
            } else {
              return h('div', this.getPriceTotal())
            }
          }
        }, {
          title: '付款额',
          align: 'center',
          render: (h, params) => {
            if (!params.row.is_total) {
              return h('div', params.row.payment)
            } else {
              return h('div', this.getPaymentTotal())
            }
          }
        }]
      }
    },
    computed: {
      ...mapGetters({
        companies_hash: 'async/companies_hash',
        teams_hash: 'async/root_teams_hash',
      }),
      expense_teams() {
        return this.expense.expense_teams;
      },
      expense_spus() {
        return this.expense.expense_spus;
      },
      invoices() {
        return this.expense.invoices;
      },
      assets() {
        if (this.expense.asset_expense_teams && this.expense.asset_expense_teams.length > 0) {
          return this.expense.asset_expense_teams.concat([{
            is_total: true
          }])
        } else {
          return []
        }
      },
      invoice_data() {
        return this.invoices.concat({
          invoice_type: '合计',
          total_price: this.invoice_total,
          allot_price: this.invoice_allot_total,
          allot_tax: this.invoice_allot_tax,
        });
      },
      invoice_total() {
        let total = 0;
        this.invoices.forEach((invoice) => {
          total = math.eval(`${total} + ${invoice.total_price}`).toFixed(2);
        });
        return total;
      },
      invoice_allot_total() {
        let total = 0;
        this.invoices.forEach((invoice) => {
          total = math.eval(`${total} + ${invoice.allot_price}`).toFixed(2);
        });
        return total;
      },
      invoice_allot_tax() {
        let total = 0;
        this.invoices.forEach((invoice) => {
          if (invoice.invoice_type === 1) {
            total = math.eval(`${total} + ${invoice.allot_tax}`).toFixed(2);
          }
        });
        return total;
      },
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      getPriceTotal() {
        return this.assets.reduce((acc, cur) => {
          if (cur.price) {
            return acc + parseFloat(cur.price)
          } else {
            return acc
          }
        }, 0).toFixed(2)
      },
      getPaymentTotal() {
        return this.assets.reduce((acc, cur) => {
          if (cur.payment) {
            return acc + parseFloat(cur.payment)
          } else {
            return acc
          }
        }, 0).toFixed(2)
      },
    }
  }
</script>
